import { createContext, FunctionComponent, PropsWithChildren, useContext } from 'react';
import { getSlugFromPathname } from '../../app-kit/helpers/getSlugFromPathname';

export const UrlContext = createContext<UrlContextData | undefined>(undefined);

interface UrlContextProps {
  url: URL;
}

interface UrlContextData {
  url: URL;
  slug: string;
}

export const useUrlContext = (): UrlContextData => {
  const context = useContext(UrlContext);
  if (context === undefined) {
    throw new Error('useUrlContext must be used within a UrlContext.Provider');
  }
  return context;
};

export const UrlContextProvider: FunctionComponent<PropsWithChildren<UrlContextProps>> = ({
  children,
  url,
}) => {
  const slugWithParams = getSlugFromPathname(url.pathname, url.search);
  return (
    <UrlContext.Provider value={{ url, slug: slugWithParams }}>{children}</UrlContext.Provider>
  );
};
